import { FC } from 'react';
import styled from 'styled-components';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Container } from '../../styles/container.styled';
import { StyledSection } from '../../styles/section.styled';
import { StyledTitle } from '../../styles/title.styled';
import CustomButton from '../UI/CustomButton/CustomButton';
import { discounts } from './discounts.constants';

const Discounts: FC = () => {
    const scrollToForm = () => {
        const el = document.getElementById('form');
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <StyledDiscounts id="discounts">
            <StyledSection>
                <Container>
                    <StyledTitle>Наши скидки</StyledTitle>
                    <StyledSwiper>
                        <Swiper
                            modules={[Navigation, Pagination]}
                            loop={true}
                            slidesPerView={1}
                            navigation
                            centeredSlides={false}
                            pagination={{ clickable: true }}
                            breakpoints={{
                                640: {
                                    slidesPerView: 1,
                                    centeredSlides: false,
                                    spaceBetween: 20,
                                    loop: true,
                                },
                                768: {
                                    slidesPerView: 2,
                                    centeredSlides: false,
                                    spaceBetween: 32,
                                    loop: true,
                                },
                                992: {
                                    slidesPerView: 3,
                                    spaceBetween: 18,
                                    centeredSlides: true,
                                    loop: false,
                                    initialSlide: 1,
                                },
                            }}
                        >
                            {discounts.map((item) => (
                                <SwiperSlide key={item.title}>
                                    <StyledCard>
                                        <StyledCardTop>
                                            <img src={item.img} alt={item.title} />
                                            <h4>{item.title}</h4>
                                            <p>{item.text}</p>
                                        </StyledCardTop>
                                        <StyledCardBottom>
                                            <CustomButton
                                                type="button"
                                                variant="primary"
                                                onClick={scrollToForm}
                                            >
                                                заказать звонок
                                            </CustomButton>
                                        </StyledCardBottom>
                                    </StyledCard>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </StyledSwiper>
                </Container>
            </StyledSection>
        </StyledDiscounts>
    );
};

const StyledSwiper = styled.div`
    && .swiper {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
        padding: 48px 40px 50px 40px;
        @media (max-width: 768px) {
            margin: 0 -15px 0 -15px;
            padding-bottom: 38px;
            padding-top: 24px;
        }
    }

    && .swiper-button-next:after,
    .swiper-button-prev:after {
        color: var(--color-primary-green);
        font-size: 20px;
    }

    && .swiper-button-prev {
        left: -8px;
        @media (max-width: 768px) {
            display: none;
        }
    }
    && .swiper-button-next {
        right: -8px;
        @media (max-width: 768px) {
            display: none;
        }
    }

    && .swiper-pagination-bullet-active {
        background: var(--color-primary-green);
    }

    && .swiper-slide-active {
        transform: scale(1.03);
        background: var(--color-bg-main);
        box-shadow: 4px 10px 20px 0px rgba(0, 100, 205, 0.25);
        @media (max-width: 992px) {
            transform: none;
            background: var(--color-bg-gray);
            box-shadow: var(--shadow-main);
        }
    }
`;

const StyledCard = styled.div`
    height: 520px;
    padding: 32px 30px 40px 30px;
    background: var(--color-bg-gray);
    box-shadow: var(--shadow-main);
    border-radius: var(--radius);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
    @media (max-width: 768px) {
        padding: 24px 22px 24px 22px;
        height: 550px;
    }

    img {
        width: 100%;
        max-width: 285px;
        height: auto;
        margin-bottom: 24px;
        object-fit: contain;
    }

    h4 {
        text-align: center;
        font-size: 22px;
        font-weight: 700;
        line-height: 130%;
        margin-bottom: 16px;
        @media (max-width: 768px) {
            font-size: 20px;
        }
    }

    p {
        font-size: 16px;
        line-height: 130%;
        text-align: center;
    }
`;

const StyledCardTop = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
`;

const StyledCardBottom = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 24px;
`;

const StyledDiscounts = styled.div`
    padding-top: 80px;
    @media (max-width: 768px) {
        padding-top: 32px;
    }
`;

export default Discounts;


